export const getGenericError = state => state.genericErrorsReducer.genericError;
